import { PlaceType } from '@hcs/types';

export const PLACES_TYPES_DEFAULT = [PlaceType.Cities, PlaceType.Regions];
